import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type {
  Worker,
  WorkerFull,
  WorkerListItem,
  AverageRatings,
  Achievements,
  Contract,
  Scout,
  SearchParams,
} from 'types/worker'
import { WorkerReview } from 'types/worker_review'
import { PaginationParameter } from '../common/pagination'

const resource = 'workers'

export const requests = {
  fetchWorkers: (params: SearchParams & PaginationParameter) => {
    return axiosForGigbaseBiz.get<DataResponse<Worker[]>>(resource, {
      params: params,
    })
  },
  fetchWorker: (id: string) => {
    return axiosForGigbaseBiz.get<DataResponse<WorkerFull>>(`${resource}/${id}`)
  },
  fetchAverageRating: (id: string) => {
    return axiosForGigbaseBiz.get<DataResponse<AverageRatings>>(
      `${resource}/${id}/average_ratings`,
    )
  },
  fetchReviews: (id: string, order: string, page: number, limit: number) => {
    return axiosForGigbaseBiz.get<DataResponse<WorkerReview[]>>(
      `${resource}/${id}/reviews`,
      {
        params: {
          order,
          page,
          limit,
        },
      },
    )
  },
  fetchAchievements: (id: string) => {
    return axiosForGigbaseBiz.get<DataResponse<Achievements>>(
      `${resource}/${id}/achievements`,
    )
  },
  fetchContracts: (id: string, page: number, limit: number) => {
    return axiosForGigbaseBiz.get<DataResponse<Contract[]>>(
      `${resource}/${id}/contracts`,
      {
        params: {
          page,
          limit,
        },
      },
    )
  },
  fetchScouts: (id: string, page: number, limit: number) => {
    return axiosForGigbaseBiz.get<DataResponse<Scout[]>>(
      `${resource}/${id}/scouts`,
      {
        params: {
          page,
          limit,
        },
      },
    )
  },
  fetchWorkedWorkers: (page: number, limit: number) => {
    return axiosForGigbaseBiz.get<DataResponse<WorkerListItem[]>>(
      `/worked_workers`,
      {
        params: {
          page,
          limit,
        },
      },
    )
  },
  fetchOfferLetterWorkers: (page: number, limit: number) => {
    return axiosForGigbaseBiz.get<DataResponse<Worker[]>>(
      `/offer_letter_workers`,
      {
        params: {
          page,
          limit,
        },
      },
    )
  },
}
